var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_3",
    "data-name": "Layer 3",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M62,21H47.473a16,16,0,1,0-30.946,0H2a1,1,0,0,0-1,1V62a1,1,0,0,0,1,1H62a1,1,0,0,0,1-1V22A1,1,0,0,0,62,21ZM27.182,43.057,3,60.074V24.057Zm1.768,1.2a6.642,6.642,0,0,0,6.1,0L58.842,61H5.158Zm7.868-1.2L61,24.058V60.074ZM32,3A14,14,0,1,1,18,17,14.015,14.015,0,0,1,32,3Zm0,30A16.017,16.017,0,0,0,46.822,23H59.109L34.955,41.979a4.916,4.916,0,0,1-5.909,0L4.891,23H17.178A16.017,16.017,0,0,0,32,33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M32.5,26H37V24H32.5A8.51,8.51,0,0,1,24,15.5a7.5,7.5,0,0,1,15,0V18a2,2,0,0,1-2,2,1,1,0,0,1-1-1V10H34v1.25A4.4,4.4,0,0,0,32.585,11H32a5,5,0,0,0,0,10h.586a4.37,4.37,0,0,0,1.869-.43A2.993,2.993,0,0,0,37,22a4,4,0,0,0,4-4V15.5a9.5,9.5,0,0,0-19,0A10.512,10.512,0,0,0,32.5,26ZM32,19a3,3,0,0,1,0-6h.585A2.4,2.4,0,0,1,34,13.466v5.068A2.4,2.4,0,0,1,32.586,19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3bebdc253dc19d422ca4b95285abacb9.svg";
export { ForwardRef as ReactComponent };